import style from './Pending.module.css';
import i18n from "../../i18n";
import {AiOutlineInfoCircle} from 'react-icons/ai';
import Navbar from "../../components/Navbar/Navbar";
import { useTranslation } from 'react-i18next';
import PaymentInfoItem from '../Cart/PaymentInfoItem/PaymentInfoItem';
import { useParams } from 'react-router';
import {IoArrowBack, IoArrowForward} from "react-icons/io5";
import { useEffect } from 'react';
import getPingUrl from '../../Api/Requests/get-ping-url';

const MAX_POLL_ATTEMPTS = 30;
const POLL_INTERVAL_MS = 1000;

const Pending = () => {
    const {t} = useTranslation();
    let {paymentSecret} = useParams();
    // request-then-wait polling: one request in flight at a time, the attempt cap counts
    // requests sent, and nothing is applied after unmount
    useEffect(() => {
        let cancelled = false;
        let timeoutId: ReturnType<typeof setTimeout> | undefined;
        let attempts = 0;

        const poll = async () => {
            if (cancelled || attempts >= MAX_POLL_ATTEMPTS) return;
            attempts++;
            try {
                const response = await getPingUrl({paymentSecret : paymentSecret});
                if (cancelled) return;
                // redirect the user and stop polling
                if(response.data.redirectTo && response.data.redirectTo != ''){
                    window.location.href = response.data.redirectTo;
                    return;
                }
            } catch (error) {
                if (cancelled) return;
            }
            timeoutId = setTimeout(poll, POLL_INTERVAL_MS);
        };
        poll();

        return () => {
            cancelled = true;
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);

    return <>
        <div dir={i18n.language=='en'?'ltr':'rtl'} className={style.container}>
            <Navbar title={''} subTitle={''} referral_url={''} cancel={true} loading={false}/>
            <div className={style.row}>
                <AiOutlineInfoCircle className={`${style.color_pending} ${style.huge_icon}`}></AiOutlineInfoCircle>
            </div>
            <div className={`${style.row} mb-1`}>
                <h1 className={`${style.no_pad} ${style.bold} ${style.font_size_md}`}>{t('payment.pending')}</h1>
            </div>
            <div className={`${style.payment_info_container_style} mt-3 mb-2 `}>
                <PaymentInfoItem
                    label={t('order.no')}
                    value={paymentSecret}
                    type={'bold'}
                    cardId={true}
                    extra='copy'
                    isTotal={false}

                />
            </div>
            <div className={`row ${style.button_container}`}>
                <button className={`${style.btn}`} onClick={() => {}}>
                    <div className={`row`} >
                        <div className={`col-12`}>
                            <div className={`${style.buttonTitle}`}> {t('returnBack')}
                            </div>
                            <span className={`${i18n.language=='en'?`float-end`:'float-start'} `}>
                                <div className={`${style.iconContainer}`}>  
                                    {i18n.language=='en'?<IoArrowForward/>: <IoArrowBack/>}
                                </div>
                            </span>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    </>
}

export default Pending;